import type VueRouter from 'vue-router';

export default function backgroundGuard(router: VueRouter) {
  router.beforeEach((to, from, next) => {
    if (to.meta?.background) {
      document.body.style.background = to.meta?.background;
    } else {
      document.body.style.background = '';
    }
    next();
  });
}
